import { FC, ReactNode } from "react";
import styled from "styled-components";

const Block = styled.div`
  height: calc(100vh - 200px);
  overflow-y: auto;
  text-align: center;
`;

interface IProps {
  children: ReactNode;
}

const ScrollView: FC<IProps> = ({ children }) => {
  return (
    <Block>
      {children}
    </Block>
  );
}

export default ScrollView;
